import { DEMO_CLIENT_PHOTOS } from './demoClientPhotoFiles';
import { IDemoClientPhoto } from './IDemoClientPhoto';

/** The stock portraits the app carries for the invented caseload, as an instance so a test can hand in its own. */
export class DemoClientPhotoCatalog {
    static inject = () => [];

    photos: IDemoClientPhoto[] = DEMO_CLIENT_PHOTOS;
}
